import { gtag, initDataLayer, install } from 'ga-gtag';
import TagManager from 'react-gtm-module';

const consentCookieDataKey = 'consent_cookie_data';
const consentCookieSeenKey = 'consent_cookie_seen';

type GAEventType = {
  category: string;
  action: string;
  label: string;
};

export function GAEvent(
  category: string,
  action: string,
  label: string
): GAEventType {
  return {
    category,
    action,
    label,
  };
}

const cookiesPayload = {
  necessary: true,
  analytics: false,
  marketing: false,
};

export const cookiesConsentSeen = (): boolean =>
  localStorage?.getItem(consentCookieSeenKey) !== null;

export function getLocalCookiesConsent(): {
  analytics: boolean;
  marketing: boolean;
  necessary: boolean;
} {
  const consentData = localStorage?.getItem(consentCookieDataKey);
  return consentData
    ? JSON.parse(consentData)
    : cookiesPayload;
}

function setLocalCookiesConsent(selectedCookies: {
  analytics: boolean;
  marketing: boolean;
  necessary: boolean;
}) {
  localStorage?.setItem(consentCookieSeenKey, '1');
  localStorage?.setItem(consentCookieDataKey, JSON.stringify(selectedCookies));
}

export function resetLocalCookiesConsent() {
  localStorage?.removeItem(consentCookieSeenKey);
  window.location.reload(); // temporary hack until we show the banner properly again
}

export function initGTag() {
  initDataLayer();
  gtag('consent', 'default', {
    ...mapLocalConsentToGTag(),
    wait_for_update: 500,
  });
  install('G-RRCWDX1B2K');
  gtag('js', new Date());
  gtag('config', 'G-RRCWDX1B2K');
  TagManager.initialize({ gtmId: 'GTM-TK3X7RGP' });
}

export function updateConsent(analytics: boolean, marketing: boolean) {
  setLocalCookiesConsent({ necessary: true, analytics, marketing });
  gtag('consent', 'update', mapLocalConsentToGTag());
}

function mapLocalConsentToGTag(): {
  ad_user_data: 'granted' | 'denied' | undefined;
  ad_personalization: 'granted' | 'denied' | undefined;
  ad_storage: 'granted' | 'denied' | undefined;
  analytics_storage: 'granted' | 'denied' | undefined;
} {
  const { analytics, marketing } = getLocalCookiesConsent();

  return {
    ad_user_data: marketing ? 'granted' : 'denied',
    ad_personalization: marketing ? 'granted' : 'denied',
    ad_storage: marketing ? 'granted' : 'denied',
    analytics_storage: analytics ? 'granted' : 'denied',
  };
}